import { useQuery } from '@tanstack/react-query';

import { DASHBOARDS_KEY } from './constants';
import { getDashboard } from './dashboards';

export const useGetDashboard = (id: number | null) => {
  return useQuery({
    queryKey: [DASHBOARDS_KEY, id],
    queryFn: () => getDashboard(id!),
    enabled: !!id,
  });
};
